import { render } from "./WildBookFallAnimal.vue?vue&type=template&id=a44be67c&scoped=true&ts=true"
import script from "./WildBookFallAnimal.vue?vue&type=script&lang=ts"
export * from "./WildBookFallAnimal.vue?vue&type=script&lang=ts"

import "./WildBookFallAnimal.vue?vue&type=style&index=0&id=a44be67c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44be67c"]])

export default __exports__